var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('product-options-form',{attrs:{"route":_vm.route,"kdsSectionsParent":_vm.kdsSections},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bcf5d8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/ProductOptions/ProductOptionsEdit.vue
// module id = Yf1v
// module chunks = 1